import { Component, OnInit } from '@angular/core';

import * as XLSX from 'xlsx';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  columns: string[] = [];
  tableData: any;

  arrayBuffer: any;
  file: File;

  loading = false;

  upload(event) {
    this.file = event.target.files[0];
    this.readFile();
    this.loading = true;
  }

  readFile() {
    let fileReader = new FileReader();

    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      let data = new Uint8Array(this.arrayBuffer);
      let arr = new Array();
      for (let i = 0; i != data.length; ++i) {
        arr[i] = String.fromCharCode(data[i]);
      }
      let bstr = arr.join('');
      let workbook = XLSX.read(bstr, { type: 'binary' });
      let first_sheet_name = workbook.SheetNames[0];
      let worksheet = workbook.Sheets[first_sheet_name];
      this.tableData = XLSX.utils.sheet_to_json(worksheet, { raw: true });
      console.log(this.tableData);
      this.getColumns(this.tableData);
    };

    fileReader.readAsArrayBuffer(this.file);
  }

  getColumns(data) {
    let temp = [];

    for (let child of data) {
      temp.push(...Object.keys(child));
    }
    this.columns = Array.from(new Set(temp));

    this.loading = false;
  }
}
